import { useState } from 'react'
import { navigate } from 'gatsby'
import clsx from 'clsx'
import { ColumnsType, Table, TableProps, Tag } from 'components/common'
import { Discount } from 'lib/graphql/storeadmin'

type InternalProps = TableProps<Discount>
type Actions = Pick<InternalProps, 'onChange' | 'onRow'>

export interface DiscountTableProps
  extends Omit<InternalProps, 'onChange' | 'onRow'> {
  dataSource: Array<Discount>
  loading: boolean
}

const columns: ColumnsType<Discount> = [
  {
    key: 'title',
    title: 'ディスカウント名',
    dataIndex: 'title',
    align: 'center',
  },
  {
    key: 'product',
    title: '対象施設',
    dataIndex: 'product',
    align: 'center',
  },
  {
    key: 'canOverlap',
    title: '重複可否',
    dataIndex: 'canOverlap',
    align: 'center',
    render: (value) => (value ? '可' : '不可'),
  },
  {
    key: 'discountPercent',
    title: 'ディスカウント率',
    dataIndex: 'discountPercent',
    align: 'center',
    render: (value) => {
      switch (value) {
        case 'ONE_HALF':
          return '1 / 2'
        case 'TWO_THIRD':
          return '2 / 3'
        case 'FULL':
          return '全額減免'
        default:
          break
      }
    },
  },
  {
    key: 'usageLimit',
    title: '最大可能回数',
    dataIndex: 'usageLimit',
    align: 'center',
  },
  {
    key: 'status',
    title: 'ステータス',
    dataIndex: 'status',
    align: 'center',
    render: (value) => {
      switch (value) {
        case 'ACTIVE':
          return <Tag color={'success'}>アクティブ</Tag>
        case 'ARCHIVED':
          return <Tag color={'error'}>アーカイブ</Tag>
        default:
          throw new Error('status should be ACTIVE or ARCHIVED')
      }
    },
  },
]

type TablePagination = {
  current: number
  pageSize: number
}

export const DiscountTable = ({
  dataSource,
  loading,
}: DiscountTableProps): JSX.Element => {
  const [pagination, setPagination] = useState<TablePagination>({
    current: 1,
    pageSize: 10,
  })

  const onChange: Actions['onChange'] = (pagination) => {
    setPagination({
      current: pagination.current,
      pageSize: pagination.pageSize,
    })
  }

  const onRow: Actions['onRow'] = (record, action) => {
    return {
      onClick: async (event) => {
        await navigate(`./${record.id}`)
      },
    }
  }

  // TODO: GraphQL ページネーション実装後、ページネーション機能を Table から Pagination へ切り出す
  return (
    <Table<Discount>
      sticky
      rowClassName={clsx('cursor-pointer')}
      dataSource={dataSource}
      columns={columns}
      onChange={onChange}
      onRow={onRow}
      pagination={pagination}
      loading={loading}
    />
  )
}
